export function guessCountryFromLocale(locale: string) {
  switch (locale) {
    case "fr-FR":
      return "FR"
    case "en-AU":
      return "AU"
    default:
      return "GB"
  }
}
